import React, { useContext, useRef, useState } from 'react';

import classnames from 'classnames';
import { compose } from 'redux';

import { reloadCompany } from 'common/actions/company';
import Portal from 'common/common/Portal';
import { CompanyContext } from 'common/containers/CompanyContainer';
import { LocationContext } from 'common/containers/RouterContainer';
import connect from 'common/core/connect';
import Link from 'common/Link';
import Tappable from 'common/Tappable';
import getOnboardingTasks, {
  OnboardingLabels,
  OnboardingLinks,
} from 'common/util/getOnboardingTasks';

import 'css/components/subdomain/admin/_AdminOnboardingProgress.scss';

const _AdminOnboardingChecklist = ({ checklist, company, onClose, reloadCompany, shown }) => {
  // context
  const location = useContext(LocationContext);

  if (!shown) {
    return null;
  }

  const onDashboard = location.pathname === '/admin';
  return (
    <div className="checklist">
      <div className="header">
        <div className="title">Canny Onboarding</div>
        <Tappable onTap={onClose}>
          <div className="exitButton icon icon-x" />
        </Tappable>
      </div>
      <div className="description">
        <div className="text">Complete these steps to get&nbsp;started</div>
      </div>

      <div className="todos">
        {checklist.map(({ completed, name }) => {
          const label = OnboardingLabels[name];
          const link = OnboardingLinks[name];
          return (
            <div
              key={name}
              className={classnames('todo', {
                completed,
              })}>
              <div className="checkbox">
                <div className="icon-check" />
              </div>
              <div className="item" href={link} rel="noopener" target="_blank">
                <div className="words">
                  <div className="label">{label}</div>
                </div>
                {completed && <div className="popper">🎉</div>}
                <div className="spacer" />
              </div>
            </div>
          );
        })}
      </div>
      {!onDashboard && (
        <Link className="help" onTap={onClose} to="/admin">
          <div className="link">Onboarding dashboard</div>
          <div className="arrow">→</div>
        </Link>
      )}
    </div>
  );
};

const AdminOnboardingChecklist = compose(connect(null, { reloadCompany }))(
  _AdminOnboardingChecklist
);

const AdminOnboardingProgress = (props) => {
  // context
  const company = useContext(CompanyContext);
  const { billingData, stats } = company;
  const { menuPosition = 'right' } = props;

  // state
  const [showChecklist, setShowChecklist] = useState(false);

  // refs
  const progressBarRef = useRef();

  if (!billingData || !stats) {
    return null;
  }

  const { onboardedAt } = stats;
  if (onboardedAt) {
    return null;
  }

  const checklist = getOnboardingTasks(company);
  const completedItems = checklist.filter(({ completed }) => completed);
  const progress = (completedItems.length / 5) * 100;

  return (
    <button
      className={classnames('adminOnboardingProgress')}
      onClick={() => setShowChecklist(!showChecklist)}
      ref={progressBarRef}>
      <div className="content">
        <div className="left">
          <div className="message">Set up Canny</div>
        </div>
        <div className="break" />
        <div className="right">{completedItems.length}/5</div>
      </div>
      <div className="progressBar">
        <div className="progress" style={{ width: `${progress}%` }} />
      </div>
      <Portal
        align="end"
        position={menuPosition}
        className="onboardingChecklistPortal"
        onBlur={() => setShowChecklist(false)}
        relativeToRef={progressBarRef}>
        <AdminOnboardingChecklist
          checklist={checklist}
          company={company}
          onClose={() => setShowChecklist(false)}
          shown={showChecklist}
        />
      </Portal>
    </button>
  );
};

export default AdminOnboardingProgress;
